import styled from "@emotion/styled";
import { CheckIcon, Cancel01Icon } from "src/assets/icons";
import {
  BACKGROUND_LIGHT,
  DISABLED_COLOR,
  DISABLED_SECONDARY,
  MID_GREY,
  OLD_BLUE,
} from "src/constants/colors";

const ToggleWrapper = styled.div<{ selected?: boolean; disabled?: boolean }>`
  display: flex;
  width: 25px;
  height: 16px;
  padding: 3px;
  justify-content: ${({ selected }) => (selected ? "flex-end" : "flex-start")};
  align-items: center;
  flex-shrink: 0;
  border-radius: 999px;
  background: ${({ selected, disabled }) => {
    if (disabled) return DISABLED_SECONDARY;
    return selected ? OLD_BLUE : MID_GREY;
  }};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  boxsizing: border-box;
  transition: background 0.2s ease-in-out;
`;

const IconWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ disabled }) => (disabled ? MID_GREY : BACKGROUND_LIGHT)};
  border-radius: 150px;
`;

const Icon = styled.div<{
  visible?: boolean;
  disabled?: boolean;
  selected?: boolean;
}>`
  position: absolute;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: scale(${({ visible }) => (visible ? 1 : 0.8)});
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${({ disabled, selected }) => {
    if (disabled) return DISABLED_SECONDARY;
    return selected ? OLD_BLUE : DISABLED_COLOR;
  }};
`;

export default ({
  selected,
  setSelected,
  disabled,
}: {
  selected: boolean;
  setSelected: (value: boolean) => void;
  disabled?: boolean;
}) => {
  return (
    <ToggleWrapper
      selected={selected}
      onClick={() => !disabled && setSelected(!selected)}
      disabled={disabled}
    >
      <IconWrapper disabled={disabled}>
        <Icon visible={!selected} selected={selected} disabled={disabled}>
          <Cancel01Icon width="6" height="6" strokeWidth="3" />
        </Icon>
        <Icon visible={selected} selected={selected} disabled={disabled}>
          <CheckIcon width="8" height="8" strokeWidth="3" />
        </Icon>
      </IconWrapper>
    </ToggleWrapper>
  );
};
